
        import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260203-36a4996a/ui-products/wspc/node_modules/ui-core/plugins/tabs/js/tabs';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260203-36a4996a/ui-products/wspc/node_modules/ui-core/plugins/tabs/js/tabs-accessibility';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260203-36a4996a/ui-products/wspc/components/tabs/js/tabs';
  
const main = (UX) => {
    const $tab = Array.prototype.slice.call(document.getElementsByClassName('tab'))

try {
        if ($tab.length ) {
            UX.tab.init($tab);
        }
    } catch (err) {
        console.error(err);
    }
    
}

        export default main;
        